import { IoClose } from 'react-icons/io5';
import { Modal, ModalBody, ModalContent, ModalHeader, Spinner } from '@ds';
import { TmdxResourceCard } from '@features/components/ResourceCards';
import SectionRow from '@features/components/CaseOverview/components/SectionRow/SectionRow';
import { OcsConsoleData } from '@/api/apis/resources';
import { CaseOCSConsoleResource, CaseResource, OrganType, ResourceLogisticsStatus } from '@/api/apis/case';
import { resourceLogisticsStatusNames } from '@/constants/resources.constants';
import { ViewResourceModalFooter } from './ViewResourceModalFooter';

const REMOVE_ALLOWED_STATUSES = [ResourceLogisticsStatus.Reserved, ResourceLogisticsStatus.Booked];

export type ViewDeviceModalProps = {
  title: string;
  resource?: CaseResource<CaseOCSConsoleResource>;
  isOpen: boolean;
  isLoading: boolean;
  isAssignEnabled: boolean;
  isRemoveEnabled: boolean;
  organType?: OrganType;
  size?: 'md' | 'xs' | 'sm' | 'lg' | 'xl' | '2xl' | '3xl' | '4xl' | '5xl' | 'full';
  onRemove: () => void;
  onAssign: () => void;
  onClose: () => void;
};

export const ViewDeviceModal = ({
  title,
  resource,
  isOpen,
  isLoading,
  isAssignEnabled,
  isRemoveEnabled,
  organType,
  size = 'md',
  onRemove,
  onAssign,
  onClose,
}: ViewDeviceModalProps) => (
  <Modal
    size={size}
    isOpen={isOpen}
    onClose={onClose}
    backdrop="opaque"
    closeButton={<IoClose size={45} style={{ top: 15 }} />}
    classNames={{
      base: 'px-6 bg-base-80',
      body: 'border-b-1 border-base-30 px-0 py-6 text-l-r',
      header: 'px-0 font-secondary text-hl! text-base-20',
      footer: 'px-0 flex gap-6',
      wrapper: 'z-420',
      backdrop: 'z-419',
    }}
  >
    <ModalContent>
      {() => (
        <>
          {isLoading && (
            <div className="absolute top-0 left-0 flex justify-center items-center z-50 w-full h-full bg-white bg-opacity-40">
              <Spinner size="md" />
            </div>
          )}
          <ModalHeader>{title}</ModalHeader>
          <ModalBody>
            <TmdxResourceCard
              className="bg-base-90 pl-4 py-3"
              label="Actions"
              list={[]}
              type="device"
              title={(resource!.data! as OcsConsoleData).ocsConsoleName}
              subTitle={(resource!.data! as OcsConsoleData).fullSerialNumber}
              phoneNumber=""
              isReadOnly
              menuDisabled
              chipProps={{
                status: resource!.logisticsStatus,
              }}
              chipText={resourceLogisticsStatusNames[resource!.logisticsStatus]}
              avatarProps={{
                type: 'device',
                size: 'xl',
                radius: 'full',
                organ: organType,
                src: (resource!.data! as OcsConsoleData).logoPath,
              }}
            />
            <div className="flex flex-col gap-4 p-6 bg-base-70 rounded-xl shadow-s">
              {(resource!.data! as OcsConsoleData).hub && (
                <SectionRow label="NOP HUB">{(resource!.data! as OcsConsoleData).hub!.name}</SectionRow>
              )}
              <SectionRow label="Last in use">{resource?.data?.lastInUseDaysAgo}d</SectionRow>
            </div>
          </ModalBody>
          <ViewResourceModalFooter
            resource={resource}
            isLoading={isLoading}
            isAssignEnabled={isAssignEnabled}
            isRemoveEnabled={isRemoveEnabled}
            removeAllowedStatuses={REMOVE_ALLOWED_STATUSES}
            onAssign={onAssign}
            onRemove={onRemove}
          />
        </>
      )}
    </ModalContent>
  </Modal>
);
